// see MY RESERVATION
// "MAKE A RESERVATION" button

import React from "react";
import moment from "moment";
import { toBool } from "../../JS/utility";
import { formatMinutesToTimeFormat } from "../../JS/utility";
import { useEffect, useState } from "react";
import { setGoHome } from "../../action/homeAction";
import { withTranslation } from "react-i18next";
import { bookMyActivity, getMyActivities } from "../../../action/activityBooking";
import { connect } from "react-redux";
import { getDefaultAnalyticsLabel } from "../../JS/utility";

import { CMSPath } from "../../../config/constant";
import { sendAnalytics } from "../../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { scrollToTop } from "../../../JS/scrollToTop";
import { popupOpenClose } from "../../../action/action";




function Activities4(props) {
    const { t } = props

    const [selectedActivity, setSelectedActivity] = useState(props.bookingData.selectedActivity?props.bookingData.selectedActivity:null)


    const handleNext = () => {
        if(selectedActivity==null){
            props.popupOpenClose(true, t("activityBooking.select_activity_popup"));
            return;
        }
        props.next({
            selectedActivity
        })

    }
    useEffect(() => {
        scrollToTop();
    }, [])

    return (
        <>
            <header className="inner-pages w-footer subpages">
                <a className="button-back" onClick={() => props.handleGoBack()}></a>
                <div className="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                </div>
            </header>
            <section class="widgets spa-listing">
                <div class="widget-header">
                    {props.currentWidgetObj.widgetHeaderImageUrl && (
                        <div class="widget-header-img">
                            <img
                                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                                alt={props.currentWidgetObj.displayName}
                            />
                        </div>
                    )}

                    <div class="widget-header-title">{t(`activityBooking.act4_heading`)}</div>
                    <div class="widget-header-subtitle">
                        {t(`activityBooking.act4_subheading`)}
                    </div>

                </div>


                {!(props.activitiesAvailable) || (props.activitiesAvailable.length==0)
                ?
                    (
                        <div class="widgets">
                            <div class="gallery-slides itinerary-list">
                        <div className="no_reservation">
                            {t("activityBooking.no_activity_found")}
                        </div>
                        </div>
                        </div>
                    )
                :


                    
                <div class="row" style={{ marginBottom: '4px' }}>
                    <div class="col">
                        <div class="detail-body stay-body">
                            <form>
                                {/* <p class="heading">{t("activityBooking.available_activities")}</p> */}
                                <div class="form-row">
                                    <div class="form-options">
                                        {props.activitiesAvailable && props.activitiesAvailable.length > 0 && props.activitiesAvailable.map((activity) => (
                                            <label class="radio-group"
                                                onClick={() => setSelectedActivity(activity)}
                                            >
                                                <input
                                                    type="radio"
                                                    name="Times"
                                                    checked={selectedActivity && activity.appointmentId == selectedActivity.appointmentId}
                                                />
                                                <div class="radio-content">
                                                    <p class="heading">{activity.serviceName}</p>
                                                    {activity.description}
                                                    <div class="options">
                                                        <div class="date"> {
                                                            moment(activity.date).format((props.dateFormat).toUpperCase())
                                                        }</div>
                                                        <div class="startTime"> 
                                                            {formatMinutesToTimeFormat(activity.startTime, toBool(props.timeFormat))}
                                                        </div>
                                                        <div class="duration">{`${activity.duration
                                                            } ${t("activityBooking.minutes")}`}</div>
                                                        <div class="amount">{`${props.currencyCode} ${activity.price}/person`}</div>
                                                    </div>
                                                </div>
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </form>
                        </div> </div> </div>
                }





                <div class="row">
                    <div class="form-controls">
                        { props.activitiesAvailable && props.activitiesAvailable.length > 0 &&<button onClick={handleNext}>{t("spaBooking.continue")}</button>}
                        <button onClick={props.handleGoBack}>{t('spaBooking.back')}</button>
                    </div>
                </div>





            </section>
        </>
    )
}
const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        timeFormat:
            state.store.home.clientConfig.extraConfigParam &&
            state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        currencyCode: state.store.home.clientConfig.currencyDetails
            ? state.store.home.clientConfig.currencyDetails.code
            : "",
    }
}

const mapDispatchToProps = { setGoHome, closeOrderPopUp, sendAnalytics, popupOpenClose }

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('translations')(Activities4));
